import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { AssetSelectedTypeMap } from '../../../../../../../../../store/product/types';

import { FixedIncomeItemSelectedDesktop } from './desktop';
import { FixedIncomeItemSelectedMobile } from './mobile';
import { FixedIncomeItemSelectedTablet } from './tablet';

export namespace FixedIncomeItemSelectedTypes {
  export interface Props {
    offer: AssetSelectedTypeMap['fixedIncome'];
    onUpdate: (offerUpdated: AssetSelectedTypeMap['fixedIncome']) => void;
    hideLateralBar?: boolean;
  }
}

export const FixedIncomeItemSelected: React.FC<FixedIncomeItemSelectedTypes.Props> = (props) => {
  const fixedIncomeSelectedItem = useBreakpointValue({
    base: <FixedIncomeItemSelectedMobile {...props} />,
    sm: <FixedIncomeItemSelectedTablet {...props} />,
    lg: <FixedIncomeItemSelectedDesktop {...props} />,
  });

  return fixedIncomeSelectedItem;
};
